import React from 'react'
import {
  ChevronLeft,
  ChevronRight
} from 'react-feather'

const Item = ({children, active}) => {
  return (
    <p className={`mx-3 ${active ? 'text-primary' : 'cursor-pointer'}`}>
      {children}
    </p>
  )
}

const Pagination = () => {
  return (
    <div className="flex justify-center text-gray-999 mt-8 lg:mt-16 mb-8">
      <Item><ChevronLeft/></Item>
      <Item active>1</Item>
      <Item>2</Item>
      <Item>3</Item>
      <Item>4</Item>
      <Item>...</Item>
      <Item>20</Item>
      <Item><ChevronRight/></Item>
    </div>
  )
}

export { Pagination }